(function () {
  'use strict';

  angular
    .module('app.static', [])

    .directive('quickOrder', function () {
      return {
        restrict: 'A',
        scope: true,
        bindToController: {
          device: '<',
          message: '@'
        },
        controllerAs: 'quickOrderCtrl',
        /* @ngInject */
        controller: ["$scope", "$element", "$timeout", "$http", "AppService", "CartService", "ModalService", "toastr", function ($scope, $element, $timeout, $http, AppService, CartService, ModalService, toastr) {
          var ctrl = this;

          ctrl.showPopover = true;
          ctrl.quantity = 1;

          ctrl.setQuantity = function (qty) {
            ctrl.quantity = qty;
          };

          ctrl.keyAddToCart = function (event) {
            if (event.which === 13) {
              event.preventDefault();
              ctrl.addToCart();
            }
          };

          ctrl.addToCart = function () {


           if (ctrl.products.length && !ctrl.products[0].AllowAddToCart) {
                  
                  ctrl.openPopover = false;
                  ModalService.show(
                      '/Template/Modal/ModalQuickView',
                      {
                          url: ctrl.products[0].URL
                      },
                      'lg',
                      null,
                      null,
                      ctrl.device,
                      null
                  );
              } else {

               

            if (!ctrl.query || ctrl.query === '') return;

            $scope.$emit('showPageLoader', true);

            $element.find('.input-quantity .form-control').blur();

            var products = [{
              Reference: ctrl.query,
              quantity: ctrl.quantity !== '' ? ctrl.quantity : 1
            }];

            AppService.addToCart(products)
              .then(function (response) {
                AppService.getTranslate()
                  .then(function (translate) {
                    if (response.status === 'OK') {
                      ctrl.query = '';
                      ctrl.quantity = 1;
                      ctrl.products = [];
                      ctrl.openPopover = false;
                      $scope.$broadcast('angucomplete-alt:clearInput');
                      $scope.$broadcast('angucomplete-alt:setFocus');
                      $scope.$broadcast('rb.input.quantity:clearInput');
                      AppService.updateParams(response.results);
                      toastr.success('', translate.messages.ReferenceAjoutee, {
                        allowHtml: true,
                        extraData: {
                          template: 'toast_message.tpl'
                        }
                      });
                      AppService.checkAvailability()
                        .then(function (checkResponse) {
                          if (checkResponse.status === 'OK') {
                            if (checkResponse.results.DeleteQuantityLines) {
                              var deleteQuantityLine = checkResponse.results.DeleteQuantityLines;
                              if (deleteQuantityLine.length) {
                                CartService.update(ctrl, checkResponse.results.VisitorContext);
                                ctrl.alertAvailability(deleteQuantityLine);
                              }
                            }
                          }
                        })
                        .catch(function (error) {
                          console.error(error);
                        });
                    } else {
                      var title = response.status === 'PRODUCT_REF_NOT_FOUND' ? translate.messages.ReferenceError : translate.errors.ErrorHasOccurred;
                      var message = response.status === 'PRODUCT_REF_NOT_FOUND' ? '' : translate.errors.TryLater;
                      toastr.warning(message, title, {
                        allowHtml: true,
                        extraData: {
                          template: 'toast_message.tpl'
                        }
                      });
                    }
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
                $scope.$emit('showPageLoader', false);
              })
              .catch(function (error) {
                console.error(error);
              });
              };
          }

          ctrl.alertAvailability = function (data) {
            ModalService.show(
              '/Template/Cart/ModalAlertAvailability',
              {
                DeleteQuantityLines: data
              }
            );
          };

          ctrl.inputChanged = function (value) {
            ctrl.query = value;
            ctrl.openPopover = false;
          };

          ctrl.searchCallback = function (selected) {
            if (typeof selected === 'undefined') return;
            if (typeof selected.Reference === 'undefined') return;

            ctrl.query = selected.Reference;
            $http.post('/Search/AutoCompleteReferenceQuery', {
              QueryFullText: ctrl.query,
              CategoryId: '',
              NbFrom: '0',
              NbSize: '1',
              withCatalogs: false
            })
            .then(function (response) {
              ctrl.getResponse(response.data, ctrl.query);
              $scope.$broadcast('rb.input.quantity:changeInput', '');
              $element.find('.input-quantity .form-control').focus();
            })
            .catch(function (error) {
              console.error(error);
            });
          };

          ctrl.searchAPI = function (userInputString, timeoutPromise) {
            return $http.post('/Search/AutoCompleteReferenceQuery', {
              QueryFullText: userInputString,
              CategoryId: '',
              NbFrom: '0',
              NbSize: '30',
              withCatalogs: false
            }, {timeout: timeoutPromise});
          };

          ctrl.getResponse = function (data, str) {
            ctrl.query = str;
            ctrl.products = data.results;

            //ctrl.TEST = ctrl.products[0].IsKit;

            $.each([ctrl.products], function (key, value) {
                console.log(key, value);
            });

            /*console.log(JSON.stringify(ctrl.products))
              IsCustomizable
                IsGroupingProduct

              */

            //|| (ctrl.products[0].IsGroupingProduct)

            if ((ctrl.products[0].IsKit) || (ctrl.products[0].IsCustomizable)  ) {

                console.log('disabled add to cart');
                ctrl.addToCartActive = false;
                ctrl.addToCartActiveDisabled = true;
                ctrl.UrlProduct = ctrl.products[0].URL;
                ctrl.openPopover = true;
            
            } else {

                ctrl.addToCartActive = true;
                ctrl.addToCartActiveDisabled = false;

                if ((ctrl.products.length === 1)) {
                    ctrl.openPopover = true;
                    $scope.$broadcast('rb.input.quantity:changeInput', '');
                    $element.find('.input-quantity .form-control').focus();
                }

            }

            

            $timeout(function () {
              $element.find('.dropdown-menu.with-img').trigger('scroll');
            }, 100);

            return data;
          };

          ctrl.goSearch = function (str) {
            if (str !== '') {
              ctrl.searchCallback({Reference: str});
            }
          };

        }]
      };
    });

})();
